module.exports = __webpack_public_path__ + "static/media/logo.fff54b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 251
// module chunks = 0